export default __webpack_public_path__ + "static/media/naci2.c5e3267a.png";